import React from 'react';
import cx from 'classnames';
import {texts} from './texts';
import styles from './UpdateStatus.module.scss';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import {apiLocker, UpdateStatusTypes} from '../../../../../stores/Form/API_Locker';

type Props = {
    session: string;
};

export const UpdateStatus = observer(({session}: Props) => {
    const updateData = apiLocker.getDataBySession(session);
    const show = updateData && updateData.status !== UpdateStatusTypes.none;
    const status = updateData?.status;

    if (!show) return null;

    if (status === UpdateStatusTypes.updating) {
        return (
            <div className={cx(styles.component, styles.updating)}>
                <div className={styles.spinner} />
                {texts.updating}
            </div>
        );
    } else if (status === UpdateStatusTypes.saved) {
        return (
            <div className={cx(styles.component, styles.success)}>
                <Icon componentClasses={styles.icon} icon={PriorityIcon.roundCheck} /> {texts.saved}
            </div>
        );
    }
    return null;
});
